import React from 'react';
import Footer from '../Footer/Footer';
import customImage from '../../Assets/Images/services.jpg'; // Replace with an actual image or reuse aboutImage if needed

import './Services.css';

const Custom = () => {
  return (
    <div className="services-page-main-sub">
      <div className="services-content-box">
        <div className="services-top-row">
          <div className="services-text-left">
            <h1>Custom & Unique Projects</h1>
            <p>
              Specialized custom work and one-of-a-kind projects tailored to your unique needs.
            </p>
            <p>
              Whether it’s complex electronics assembly, bespoke modifications, or custom solutions, we provide personalized service with expert craftsmanship.
            </p>
          </div>

          <div className="services-right-column">
            <div className="services-image-right">
              <img src={customImage} alt="Custom & Unique Projects" />
            </div>
          </div>
        </div>

        <div className="services-bottom-text">
          <p>
            Contact us to discuss your custom project — we’ll work closely with you to bring your ideas to life.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Custom;
